import axios from "axios";
import { CommonAxiosService } from "./common-axios-service";

export class WhatsAppNotificationService extends CommonAxiosService {
    private getURLwithMainEndPoint(childUrl: string) {
        return 'http://206.189.138.212:3232/api/bi-message' + childUrl;
    }

    async appeCommonTemplete(phnNo: number, body: any, templateName: string) {
        try {
            const textMessagePayload = {
                "messaging_product": "whatsapp",
                "to": phnNo,
                "type": "template",
                "template": {
                    "name": templateName,
                    "language": {
                        "code": "en_us"
                    },
                    "components": [
                        {
                            "type": "body",
                            "parameters": [
                                {
                                    "type": "text",
                                    "text": body,
                                }
                            ]
                        }
                    ]
                }
            };
            await axios.post(
                'https://graph.facebook.com/v19.0/437711296082941/messages',
                textMessagePayload,
                {
                    headers: {
                        Authorization: `Bearer EAAPlWQYnjvkBO3nJuYbGL6Afc6AKwCt3wz4vp4LD6XSMAWwQkgOeCaDcObuHzbkW4z8QSXUZCO1CvMzVCZBTAtpTZA0sIinwZCPcKBiZCQf4YukEAQ9LB5a6ofpQO4oSmGbBZCzRq2T2GRPYZCo3BAguGhmv9NfrZAaFOZByNUVjoVRExpG2SgROsinlVIM5FJzqUehtG3QfjHeLW7MXM`
                    }
                },
            );
        } catch (error) {
            console.log("Error while executing [sendingDetails] : " + error)
        }
    }
}